var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('a',{class:_vm.clazz,attrs:{"href":"#"},on:{"click":function($event){$event.preventDefault();return _vm.click.apply(null, arguments)}}},[_vm._v(" "+_vm._s(_vm.memberName)+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }